export enum ProductCategory {
  OUTDOOR_CLASSROMS = "Outdoor Classrooms",
  ACTIVE_PLAY = "Active Play",
  IMAGINATION_AND_CREATIVE = "Imaginative & Creative",
  SPORT = "Sport",
  FURNITURE_FENCING_STORAGE = "Furniture, Fencing & Storage",
  SURFACING_LANDSCAPING = "Surfacing & Landscaping",
  INDOOR_FURNITURE = "Indoor Furniture",
  EARLY_YEARS_FURNITURE = "Early Years Furniture",
}
